import { render, staticRenderFns } from "./Pastille.vue?vue&type=template&id=d604a39c&name=pastille&"
import script from "./Pastille.vue?vue&type=script&lang=js&"
export * from "./Pastille.vue?vue&type=script&lang=js&"
import style0 from "./Pastille.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports